exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.demo-table-expand[data-v-480fb1f4] {\n  font-size: 0;\n}\n.demo-table-expand label[data-v-480fb1f4] {\n  width: 60px;\n  color: #99a9bf;\n}\n.demo-table-expand .el-form-item[data-v-480fb1f4] {\n  margin-right: 0;\n  margin-bottom: 0;\n}\n.status[data-v-480fb1f4] {\n  color: #ffcd56;\n  font-size: 30px;\n}\n", ""]);

// exports
